import { RefObject, useEffect } from 'react';

const useEnforceFocus = (dialogRef: RefObject<HTMLDivElement | null>, show: boolean, enforceFocus?: boolean) => {
    useEffect(() => {
        if (!show || !enforceFocus) {
            return;
        }

        const handleFocusIn = (event: FocusEvent) => {
            if (!dialogRef?.current) {
                return;
            }

            if (!dialogRef.current.contains(event.target as Node)) {
                dialogRef.current.focus();
            }
        };

        document.addEventListener('focusin', handleFocusIn);

        return () => {
            document.removeEventListener('focusin', handleFocusIn);
        };
    }, [show, enforceFocus]);
};

export default useEnforceFocus;
